export const getLogIndexes = logs => {
    return logs.filter(item => item[0] !== '_t').map((item, index) => item[0] ?? index);
};
